---
title: "Connect Slack"
description: "Connect Slack and every marketplace role can get a shared channel with its recruiters, mirrored both ways with your in-app marketplace inbox."
category: "getting-started"
keywords:
  - "Slack ATS integration"
  - "Slack recruiter channel"
  - "connect Slack recruiting"
  - "shared channel recruiters"
schema: "HowTo"
nav:
  section: "getting-started"
  order: 51
  parent: "/getting-started"
---

Connect Slack and each role you publish to the [marketplace](/guides/marketplace-hiring) can get a shared channel with every recruiter working it. Messages mirror both ways with your marketplace inbox, so the conversation is whole no matter which side someone types on.

## What it does

- One private channel per published role, named after it.
- Recruiters on the role get Slack Connect invites; the in-app thread works for them either way.
- Anything posted in Slack shows in your marketplace inbox tagged "via Slack", and replies from the app post back to the channel.
- Closing the role archives its channel.

## How to connect

<Steps>
  <li>Go to **Settings → Integrations**.</li>
  <li>Click **Connect Slack** and authorize the workspace.</li>
  <li>Optional: turn on **Create a channel for every published role**, or create channels per role from each role's dashboard.</li>
</Steps>

If the Slack card says it isn't enabled on your deployment yet, there's nothing to click — the feature lights up once your workspace's Slack app is configured.

## Without Slack

Everything works without it. The marketplace inbox is the system of record either way; Slack is a mirror, not a requirement.
